import { __read, __assign } from 'tslib';
import { useReducer, useCallback } from 'react';

function reducer(state, action) {
    var _a;
    // no change
    if (state[action.type] === action.change)
        return state;
    /*
      apply change to current state
    */
    var change = action.change;
    if (action.type === "preference" && action.change === "toggle") {
        if (state.preference === null && state.override !== null) {
            // handle the case where preference is null and layout is true so preference should become false
            // ie layout has collapsed the sidebar but the user wants it expanded
            change = state.override;
        }
        else {
            change = !state.preference;
        }
    }
    var newState = __assign(__assign({}, state), (_a = {}, _a[action.type] = change, _a));
    /*
      resolve isCollapsed
    */
    var isCollapsed = false;
    if (newState.layout)
        isCollapsed = true;
    // when layout collapses the MainNav, nullify preference
    // if it is false so that the MainNav can collapse
    if (action.type === "layout" &&
        newState.preference === false &&
        newState.layout === true) {
        newState = __assign(__assign({}, newState), { preference: null });
    }
    if (action.type === "layout" &&
        newState.layout === true &&
        newState.override === false) {
        newState = __assign(__assign({}, newState), { override: null });
    }
    if (newState.preference !== null) {
        isCollapsed = newState.preference;
    }
    // If preference has changed then disable override
    // so the nav does whatever preference was set to
    if (newState.preference !== state.preference) {
        newState = __assign(__assign({}, newState), { override: null });
    }
    if (newState.override !== null)
        isCollapsed = newState.override;
    return __assign(__assign({}, newState), { isCollapsed: isCollapsed });
}
var initialState = {
    isCollapsed: false,
    layout: null,
    preference: null,
    override: null,
};
var useLayoutSidebarCollapseState = function () {
    var _a = __read(useReducer(reducer, initialState, function (arg) { return arg; }), 2), state = _a[0], dispatch = _a[1];
    var setLayout = useCallback(function (change) { return dispatch({ type: "layout", change: change }); }, [dispatch]);
    var setPreference = useCallback(function (change) { return dispatch({ type: "preference", change: change }); }, [dispatch]);
    var setOverride = useCallback(function (change) { return dispatch({ type: "override", change: change }); }, [dispatch]);
    return __assign(__assign({}, state), { setLayout: setLayout, setPreference: setPreference, setOverride: setOverride });
};

export { useLayoutSidebarCollapseState };
//# sourceMappingURL=useLayoutSidebarCollapseState.js.map
